import React, { Component } from 'react';
import DropdownMenus from '../../Common/DropdownMenus';
import UserMenuContent from './UserMenuContent';

export default class MenuDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdownOpen: false
    };
  }

  render() {
      return (
          <DropdownMenus
            targetContent = {'Личный кабинет id ' + this.props.userId || 'undefined'}
            dropdownContent = {<UserMenuContent {...this.props}/>   }
            dropdownOpen={this.state.dropdownOpen}
          />
      );
    }
}




/** WEBPACK FOOTER **
 ** ./src/components/User/elements/MenuDropdown.jsx
 **/